const ONELINK_BASE = "https://capcut-yt.onelink.me/ch/W3Oy";

const extractTemplateId = (url) => {
  if (!url || typeof url !== "string") return null;
  const match = url.match(
    /capcut-yt\.onelink\.me.*?template_id(?:%3D|%253D|=)(\d+)/i
  );
  return match ? match[1] : null;
};

const buildFallbackOneLink = (templateId) => {
  return (
    `${ONELINK_BASE}?` +
    "af_dp=capcut%3A%2F%2Ftemplate%2Fdetail%3Fenter_app%3Dother%26" +
    "enter_from%3Dshared_other_none_template_btn%26" +
    `template_id%3D${templateId}%26template_language%3DNone` +
    "&is_retargeting=true&pid=SharedPage_other_ed_new&" +
    "deep_link_value=capcut%253A%252F%252Ftemplate%252Fdetail%253F" +
    "enter_app%253Dother%2526" +
    "enter_from%253Dshared_other_none_template_btn%2526" +
    `template_id%253D${templateId}%2526template_language%253DNone` +
    "&deep_link_sub1=%7B%22share_token%22%3A%22None%22%7D&af_xp=social"
  );
};

/**
 * Convert a CapCut OneLink URL into a redirect page that first tries the
 * `capcut://` custom URL scheme (works inside WebViews / in-app browsers) and
 * then falls back to an AppsFlyer OneLink URL.
 *
 * @param {string} url          The original CapCut link pasted by the admin.
 * @param {string} pageOrigin   The origin of the current page, e.g.
 *                              `https://c-template-indol.vercel.app`. This is
 *                              used to build the redirect page URL.
 */
export const fixCapcutLink = (url, pageOrigin) => {
  if (!url || typeof url !== "string") return url;

  const templateId = extractTemplateId(url);
  if (!templateId) return url;

  const fallback = buildFallbackOneLink(templateId);

  // If we don't have an origin (e.g. server-side), just return the OneLink fallback.
  if (!pageOrigin) return fallback;

  const redirect =
    `${pageOrigin}/open-capcut.html` +
    `?tid=${encodeURIComponent(templateId)}` +
    `&fallback=${encodeURIComponent(fallback)}`;

  return redirect;
};

/**
 * Kept for backward compatibility: returns only the AppsFlyer OneLink fallback.
 */
export const buildCapcutFallbackLink = (url) => {
  if (!url || typeof url !== "string") return url;
  const templateId = extractTemplateId(url);
  return templateId ? buildFallbackOneLink(templateId) : url;
};
